export default __webpack_public_path__ + "2d536af1afe347423ed1cd78709d5d77.png";